import { Hero } from "../components/Hero";
import { Ribbon } from "../components/Ribbon";
import { StatsBand } from "../components/StatsBand";
import { Services } from "../components/Services";
import { ExecutiveTier } from "../components/ExecutiveTier";
import { WhyUs } from "../components/WhyUs";
import { Corporate } from "../components/Corporate";
import { Events } from "../components/Events";
import { ServiceArea } from "../components/ServiceArea";
import { Testimonials } from "../components/Testimonials";
import { FollowUs } from "../components/FollowUs";
import { SpecialTeaser } from "../components/SpecialTeaser";

export default function Landing() {
  return (
    <main className="bg-paper">
      <Hero />
      <Ribbon />
      <StatsBand />
      <Services />
      <ExecutiveTier />
      <WhyUs />
      <Corporate />
      <Events />
      <SpecialTeaser />
      <ServiceArea />
      <Testimonials />
      <FollowUs />
    </main>
  );
}
